import React, { useState, useEffect } from 'react';
import {
  PackagesMini,
  PackagesMiniLite,
  PackagesMiniVisual,
  PackagesMiniTransactional
} from '@thd-olt-component-react/packages-mini';
import { extend } from '@thd-nucleus/data-sources';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';

const PackagesMiniABTest = ({ ...props }) => {
  const [packagesMiniABTestType, setPackagesMiniABTestType] = useState('default');

  useEffect(() => {
    ['transactional', 'visual', 'work-co'].forEach((type) => {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.on(`packages-mini.${type}`, (data) => {
        setPackagesMiniABTestType(data.output.enabled ? type : 'default');
      });
    });
  }, []);

  /* eslint-disable react/jsx-props-no-spreading */
  switch (packagesMiniABTestType) {
  case 'transactional':
    return <PackagesMiniTransactional {...props} />;
  case 'visual':
    return <PackagesMiniVisual {...props} />;
  case 'work-co':
    return <PackagesMiniLite {...props} />;
  default:
    return <PackagesMini {...props} />;
  }
  /* eslint-enable react/jsx-props-no-spreading */
};

PackagesMiniABTest.dataModel = extend(PackagesMini, PackagesMiniLite, PackagesMiniVisual, PackagesMiniTransactional);

const ErrorBound = withErrorBoundary(PackagesMiniABTest);

export { ErrorBound as PackagesMiniABTest };
